<template>
  <div v-if="open" class="chat-overlay">
    <div class="chat-modal" :class="messages.length ? 'background-message' : 'background-message-empty'">
      <header class="chat-header">
        <button class="close-btn" @click="$emit('closeChat')">
          &times;
        </button>
      </header>

      <template v-if="messages.length">
        <div
          class="chat-body"
          ref="messages"
        >
          <template v-for="(message, index) of messages" >
            <div class="message" :class="{'agent': message.type === 'response', user: message.type === 'request', error: message.type === 'error'}" :key="index" v-html="renderMarkdown(message.content)">
            </div>
          </template>
          <template v-if="loadingResponse">
            <div class="message agent typing">
              <span></span><span></span><span></span>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="chat-body-empty">
          <div class="content">
            <img src="https://smartagent.intelligential.tech/smart-agent-title.svg" alt="Smart Agent" class="logo" />
            <div class="content-subtitle">
            <label>¡Bienvenido!</label>
            <br>
            <label class="title">¿En qué puedo ayudarte?</label>
            </div>
          </div>
        </div>
      </template>

      <footer class="chat-footer">
        <div>
          <input
            ref="requestInput"
            type="text"
            placeholder="Escribe aquí"
            name="request"
            v-model="request"
            @keydown.enter="addRequest"
            :disabled="loadingResponse"
          />
          <button class="send" @click="addRequest">➤</button>
          <br>
        </div>
        <p>Smart Agent puede generar información imprecisa. Verifica las respuestas.</p>
      </footer>

    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import markdownFilter from '@/filters/markdown'

export default {
  props: {
    open: {
      type: Boolean,
    }
  },
  async mounted () {
    const response = await this.getHistory()
    if (response?.success === 200) {
      this.messages = response.data.history
      this.toEndScroll()
    }
    this.focusRequestInput()
  },
  data () {
    return {
      request: '',
      loadingResponse: false,
      messages: [],
      canReloadHistory: true,
    }
  },
  methods: {
    ...mapActions({
      executeChatbotRequest: 'agent/executeChatbotRequest',
      getHistory: 'agent/getHistory'
    }),
    toEndScroll () {
      this.$nextTick(() => {
        const chat = this.$refs.messages
        chat.scrollTop = chat.scrollHeight
      })
    },
    renderMarkdown (content) {
      return markdownFilter(content)
    },
    focusRequestInput () {
      this.$nextTick(() => {
        if (this.$refs.requestInput) {
          this.$refs.requestInput.focus()
        }
      })
    },
    async addRequest () {
      if (!this.request || !this.request.trim() || this.loadingResponse) {
        this.focusRequestInput()
        return
      }
      const request = this.request
      this.messages.push({
        content: this.request,
        type: 'request'
      })
      this.toEndScroll()

      this.request = null
      this.loadingResponse = true
      const data = {
        request: request,
      }

      const response = await this.executeChatbotRequest(data)
      if (response.error) {
        this.messages.push({
          content: response.error,
          type: 'error'
        })
      } else {
        this.messages.push({
          content: response.response,
          type: 'response'
        })
      }
      this.loadingResponse = false
      this.toEndScroll()
      this.focusRequestInput()
    }
  },
  watch: {
    async open (newVal) {
      if (newVal === true && this.canReloadHistory && !this.messages.length) {
        const response = await this.getHistory()
        if (response?.success === 200) {
          this.messages = response.data.history
          this.toEndScroll()
        }
        this.canReloadHistory = false
      }
      this.focusRequestInput()
    }
  }
}
</script>

<style  scoped>
.close-btn {
  width: 30px;
  height: 30px;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: #606060;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  margin-right: -12px;
  background: transparent;
}

.close-btn:hover {
  color: #606060;
  transform: scale(1.1);
}
.chat-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: flex-end;
  background: rgba(0,0,0,0.2);
  align-items: flex-end;
  z-index: 50;
}

.chat-modal {
  /* width: 400px;
  height: 55%;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 5px; */

  margin: 20px 14px;
  position: relative; /* importante para que el fondo se ancle aquí */
  width: 388px;
  height: 90vh;
  background: transparent; /* ya no fondo blanco */
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  overflow: hidden; /* para que el fondo no se desborde */
  background-image: url(https://smartagent.intelligential.tech/bg-chat.png);
  background-repeat: no-repeat;
  background-size: 90vh;
  background-position: center;
  z-index: 51;
}
.chat-modal.background-message {
  background-image: url(https://smartagent.intelligential.tech/bg-chat.png);
  background-repeat: no-repeat;
  background-size: 90vh;
  background-position: center;
}
.chat-modal.background-message-empty {
  background-image: url(https://smartagent.intelligential.tech/bg-chat_480.png) !important;
  background-repeat: no-repeat;
  background-size: 90vh;
  background-position: center;
}

.chat-header {
  display: flex;
  justify-content: end;
  align-items: center;
  padding: 0px 12px;
  color: white;
  position: relative;
}

.chat-header p {
  font-size: 1.3rem;
  color: #36475b !important;
  font-weight: 600;
  line-height: 1.125;
  padding-left: 18px;
  margin: 2px 0px;
}

.chat-body {
  flex: 1;
  padding: 12px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.chat-body-empty {
  flex: 1;
  position: relative;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.chat-body-empty .content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.chat-body-empty .logo {
  width: 68%;
}

.chat-body-empty .content-subtitle {
  font-size: 14px;
  color: #333;
  line-height: 1.4;
  margin-bottom: -55px;
  margin-top: 49px;
}

.chat-body-empty .content-subtitle .title {
  font-weight: bold;
  font-size: 16px;
}



.message {
  max-width: 75%;
  padding: 10px 15px;
  margin-bottom: 12px;
  border-radius: 15px;
  font-size: 12px;
  line-height: 1.4;
  word-wrap: break-word;

}

.message.agent {
  align-self: flex-start;
  background: #e4e8f0;
  color: #1c1f26;
  white-space: pre-line;
}

.message.user {
  align-self: flex-end;
  background: rgba(47, 84, 235, .85);
  color: #fff;
}

.message.error {
  align-self: flex-start;
  background: #ff7979;
  color: #fff;
}

.chat-footer {
  display: flex;
  padding: 8px;
  padding-bottom: 15px;
  position: relative;
  flex-direction: column;
}

.chat-footer  div {
  display: flex;
}
.chat-footer p {
  font-size: 9px;
  text-align: left;
  color: #bcbcbc;
  padding-top: 5px;
}

.chat-footer input {
  flex: 1;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #dbdbdb;
  min-height: 30px;
  font-size: 12px;
  line-height: 1.29;
  letter-spacing: normal;
  color: #222;
}
.chat-footer input ::placeholder {
  color: #E1E1E1;
}

.chat-footer input:focus-visible {
  border-color: initial;
}


.chat-footer button {
  border: none;
  padding: 5px 7px;
  cursor: pointer;
  height: 27px;
  margin-top: 3px;
}

.chat-footer .send {
  margin-left: 8px;
  background: var(--primary-color);
  color: #fff;
  border: none;
  padding: 5px 7px;
  cursor: pointer;
  border-radius: 9999px;
  height: 27px;
  margin-top: 8px;
}



.typing {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 21px;
  background: #e4e8f0;
}

.typing span {
  width: 6px;
  height: 6px;
  background: var(--primary-color);
  border-radius: 50%;
  animation: blink 1s infinite;
}

.typing span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
}
</style>